import { FileRecord, HeaderMapping, PropertyConfig, UOMS } from '@amzn/awscat-portfolio-assessment-types';

import { uomConversion } from '../../../../common/uomConversion';

export const convertStringToNumber = (str: string): number => {
    return Number(str) || 0;
};

export const convertNumberToString = (num: number): string => {
    return num.toString();
};

/**
 * Calculate the unique key of a row
 * @param dataRow
 * @param idFields
 * @param type
 */
export function getKeyFromDataRow(dataRow: string[], idFields: HeaderMapping[], type: string): string {
    const recordIds: FileRecord = idFields.reduce((currRecordIds: FileRecord, idField: HeaderMapping) => {
        const fileHeaderIndex = idField.fileHeaderIndex || 1;
        // fileHeaderIndex is 1 ahead of dataRowIndex due to DO_NOT_IMPORT
        currRecordIds[idField.portfolioProperty] = dataRow[fileHeaderIndex - 1];
        return currRecordIds;
    }, {});
    const key: string = getKey(recordIds, type);
    return key;
}

export function getKey(row: FileRecord, type: string): string {
    if (type === 'applicationServer') {
        if (!row.applicationId || !row.serverId) { return ''; }
        return JSON.stringify({
            applicationId: row.applicationId,
            serverId: row.serverId,
        });
    } else if (type === 'applicationDependency') {
        if (!row.srcAppId || !row.destAppId) { return ''; }
        return JSON.stringify({
            destAppId: row.destAppId,
            srcAppId: row.srcAppId,
        });
    } else if (type === 'databaseApplication') {
        if (!row.databaseId || !row.applicationId) { return ''; }
        return JSON.stringify({
            applicationId: row.applicationId,
            databaseId: row.databaseId,
        });
    } else {
        return row[type + 'Id'] as string;
    }
}

/**
 * Change ratio values to percentage
 * @param previewData
 * @param propertyConfig
 */
export function displayDecimalAsPercentage(previewData: FileRecord[], propertyConfig: PropertyConfig[]): void {
    previewData.map(item => {
        propertyConfig.forEach(property => {
            if (property.type === 'ratio') {
                item[property.value] = uomConversion(Number(item[property.value]), UOMS.DECIMAL, UOMS.PERCENTAGE);
            }
        });
        return item;
    });
}

/**
 * Chech if an object is empty or not
 * @param obj object, any
 */
export const isEmpty = (obj: any): boolean => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};

/**
 * Generate file types validation promise
 * @param file Uploaded file
 * @param supportedFileHeaders Defines which types are supported, must be a magic number array
 * @returns if it matches one of supported file types, return true; otherwise false
 */
export const validateMagicNumber = async (file: File, supportedFileHeaders: string[]): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onloadend = e => {
            if (e.target?.readyState !== FileReader.DONE) {
                reject(false);
            }
            let headerStr = '';
            const u8arr = (new Uint8Array(e.target?.result as ArrayBuffer)).subarray(0, 4);
            for (const item of u8arr) {
                headerStr += item.toString(16);
            }
            resolve(supportedFileHeaders.includes(headerStr));
        };
        fileReader.readAsArrayBuffer(file);
    });
};
